jQuery(function($){

  resizeWindow();
  $('#dob-canadan').mask('0000/00/00');

  $(window).resize(resizeWindow);

  var non_private_browsing = true;

  detectPrivateMode(function(is_private) {
    if (is_private) {
      non_private_browsing = false;
    } 
  });
  var isMobile = {
    Android: function() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };

  // popup                   
  $('#confirmAge').click(function(e) {
    e.preventDefault();
    $('#popup').fadeOut(1000, function() {
      if(typeof(Storage) !== "undefined") {
        if (non_private_browsing) {
          sessionStorage.buffaloShowPopup = 1;
          // wispond - show to someone who has confirmed their age for the first time
          if (sessionStorage.showWishpond != 1) {
            if ($('#trigger_wishpond').length) {
              Wishpond.perform('showPopup', 2253916);
              sessionStorage.showWishpond = 1;
            }
          }
          // out of stock- show to someone who has confirmed their age for the first time
          if ($('#outofstock').length) {
            if (sessionStorage.buffaloShowOutOfStockPopup != 1) {
              $('#outofstock').fadeIn(300);
            }   		  
          }
        }
      }                               
    });
  });
  if ($('#popup').length) {
    $(window).load(function(){
      if(typeof(Storage) !== "undefined") {
        if (sessionStorage.buffaloShowPopup != 1) {
          if (non_private_browsing) {
            $('#popup').show(0);
          }
        } else {

          if (non_private_browsing) {

            // wishpond - show to someone who has already confirmed their age in this session
            if (sessionStorage.showWishpond != 1) {
              if ($('#trigger_wishpond').length) {
                Wishpond.perform('showPopup', 2253916);
                sessionStorage.showWishpond = 1;
              }
            }

            // out of stock - show to someone who has already confirmed their age in this session
            if ($('#outofstock').length) {
              if (sessionStorage.buffaloShowOutOfStockPopup != 1) {
                $('#outofstock').fadeIn(300);
              }   		  
            }


          }
        }
      }
    });
  }

  // outofstock                   
  $('#outofstock span.close').click(function(e) {
    e.preventDefault();
    $('#outofstock').fadeOut(1000, function() {
      if(typeof(Storage) !== "undefined") {
        if (non_private_browsing) {
          sessionStorage.buffaloShowOutOfStockPopup = 1;
        }
      }                               
    });
  });

  // mobile nav
  $('#header .mobile_toggle').click(function() {
    $(this).toggleClass('open');
    $('#header .mobile_nav').slideToggle('fast');
  });

  // faq paragraphs
  $('#faq p.question').click(function() {
    $(this).toggleClass('open');
    $(this).next('p.answer').slideToggle('fast');
  });

  // grid item first word bold
  if ($('.grid-item span.title').length) {
    $('.grid-item span.title').each(function() {
      var $this = $(this);
      $this.html(function(){
        var text= $this.text().trim().split(" ");
        var first = text.shift();
        return (text.length > 0 ? "<span class='proxima_nova_bold'>"+ first + "</span> " : first) + text.join(" ");
      });
    });
  }

  // blog masonry
  if ($('#blog .grid').length) {

    var size_li = $("#blog .grid .post").size();
    var x = 6;

    if (x >= size_li) { $('#blog .loadmore a.button').hide(); }

    var $grid = $('#blog .grid').masonry({ itemSelector: '.post' });

    $('#blog .grid .post:lt(' + x + ')').show();

    $grid.imagesLoaded().progress( function() {
      $grid.masonry('layout');
    });

    $('#blog .loadmore a.button').click(function(e) {
      e.preventDefault();
      x = (x + 6 <= size_li) ? x + 6 : size_li;
      $('#blog .grid .post:lt(' + x + ')').show();
      $grid.masonry('layout');
      if (x >= size_li) { $('#blog .loadmore a.button').hide(); }
    });

  }

  // product thumbs
  $('#product .thumbs .thumb').click(function() {
    var rel = $(this).attr('rel');
    $('#product .images .cycle-slideshow').cycle('goto', rel);
  });

  // product single title
  if ($('#product h1').length) {
    $('#product h1').html(function(){
      var text= $('#product h1').text().trim().split(" ");
      var first = text.shift();
      return (text.length > 0 ? "<span class='proxima_nova_bold'>"+ first + "</span> " : first) + text.join(" ");
    });
  }

  // + / - quantity updaters
  $(document).on('click','.value-control',function(){
    var action = $(this).attr('data-action');
    var target = $(this).attr('data-target');
    var value  = parseFloat($('#' + target).val());
    if ( action == 'plus' ) {
      value++;
    }
    if ( action == 'minus' ) {
      value--;
    }
    if (value > 0) {
      $('#' + target).val(value);
    }
    $("#update-cart-control").val(1);
    if(isMobile.any()){
      $('#update-cart').trigger('click');
    }
  });  

  // mailchimp
  if ($('#mailchimp').length) {

    $('#mailchimp').validate({
      rules: {
        EMAIL: {
          required: true,
          email: true
        }
      }
    });

  }

  // mailchimp
  if ($('#page .mailchimp form').length) {

    $('#page .mailchimp form').each(function() {
      $(this).validate({
        rules: {
          EMAIL: {
            required: true,
            email: true
          }
        }
      });
    });

  }

  // instagram
  if ($('#instagram').length) {
    doInstagram();
  }

  /* BEGIN AGE VERIFICATION */

  // age verification check for logged in users
  if (cid != '') {
    if ($('#reminder').length) {
      $(window).load(function(){
        if(typeof(Storage) !== "undefined") {
          if (localStorage.blackBuffaloShowReminder != 1) {
            $.ajax({ 
              type: "GET",  
              url: appsdomain + "/check-for-verification.php?callback=checkForVerification&cid=" + cid,
              dataType: 'jsonp',
              jsonp: 'checkForVerification',
              async:'true',
              success: function(data) {
                // success
              }
            });
          }
        }
      });
    }
  }

  // reminder close
  $('#reminder a.close').click(function(e) {
    e.preventDefault();
    localStorage.blackBuffaloShowReminder = 1;
    $('#reminder').fadeOut(1000);
  });

  // reminder button
  $('#reminder a.button').click(function(e) {
    e.preventDefault();
    localStorage.blackBuffaloShowReminder = 1;
    window.location.href = "/pages/verify-age";
  });

  if ($('#verification').length) {

    $('#verification input[name="state"]').mask('AA'); 
    $('#verification input[name="zip"]').mask('00000'); 
    $('#verification input[name="dob"]').mask('0000/00/00');
    $('#verification input[name="ssn"]').mask('0000');

    $('#verification').validate({
      rules: {
        fname: {
          required: true
        },
        lname: {
          required: true
        },
        address: {
          required: true
        },
        city: {
          required: true
        },
        state: {
          required: true
        },
        zip: {
          required: true,
          number:true,
          rangelength: [5, 5]
        },
        dob: {
          required: true,
          rangelength: [10, 10]
        },
        ssn: {
          required: true,
          number:true,
          rangelength: [4, 4]
        }
      },
      submitHandler: function(form) {

        $('#verify .form').prepend('<p class="centertext" style="margin-top:20px;">Working...</p>');  

        var form_data = $('#verification').serialize();

        $('#verification input[type="submit"]').prop('disabled', true).css({ 'opacity':'0.5', 'cursor':'default'});

        /* works on maiasiber.com: */
        $.ajax({ 
          type: "GET",  
          url: appsdomain + "/form-submit.php?callback=verifyAge&form_data=" + encodeURIComponent(JSON.stringify(form_data)),
          dataType: 'jsonp',
          jsonp: 'verifyAge',
          async: 'true',
          success: function(data) {
            // success performed in callback
          }
        });

        /* testing for blackbuffaloapps.com
                  // try this: https://stackoverflow.com/questions/14095041/jquery-ajax-call-for-posting-data-to-asp-net-page-not-get-but-post
                  $.ajax({ 
                      type: "GET",  
                      url: appsdomain + "/form-submit.php",
                      dataType: 'jsonp',
                      jsonp: 'formdata',
                      jsonpCallback: encodeURIComponent(JSON.stringify(form_data)),
                      async: false,
                      success: function(data) {
                     	// success performed in callback
                    	verifyAge(data);
                      }                   
                  });*/

      }
    });

  }

  /* END AGE VERIFICATION */

});

function resizeWindow() {

  var ww = $(window).width();

  if (ww > 768) {

    $('#header .mobile_toggle').removeClass('open');
    $('#header .mobile_nav').hide(0);

    if ($('#home').length) {
      var hh = $('#header').outerHeight();
      var padding = hh;
      $('#home').css({'padding-top' : padding + 'px', 'margin-top' : '-' + hh + 'px'});
    }

  } 

}

function jsonPforInstagram(data){
  $.each(data.data,function(i,row){
    //var thumbnail = row.images.thumbnail.url.replace('s150x150/', 's640x640/'); 
    var thumbnail = row.images.standard_resolution.url;
    var insta = '<div class="col one-fourth"><a href="' + row.link + '" class="opacity hover_50" target="_blank"><img src="' + thumbnail + '" alt=""></a></div>';
    $('#instagram .cols').append(insta);	          
  });
}

function doInstagram() {
  $.ajax({
    url: 'https://api.instagram.com/v1/users/' + iuid + '/media/recent?access_token=' + itoken + '&count=4&callback=jsonPforInstagram',
    type: 'GET',
    dataType: 'jsonp',
    jsonp: 'jsonPforInstagram',
    async:'true',
    success: function(data) {
      // success	
    }
  });
}

function checkForVerification(data) {
  if (data.age_verification && data.age_verification.length > 0) {
    // age verified
    console.log(data.age_verification);
  } else {
    // hasn't verified age yet
    console.log('has not verified yet');
    if ($('#reminder').length) {
      if (localStorage.blackBuffaloShowReminder != 1) {
        setTimeout(function(){
          $('#reminder').fadeIn(1000);
        }, 3000);
        localStorage.blackBuffaloShowReminder = 1;
      }
    }
  }
}

function tagVerified(data) {

  var tag_response = $.parseJSON(data);

  if (tag_response) {

    if (tag_response.customer.id == cid) {

      $('#verify .form').html('<p class="success">Success! We were able to successfully verify your age. If you were in the middle of checking out, <a href="/checkout">please continue</a>!</p>').fadeIn(300);

    } else {

      $('#verify .form').html('<p class="error">There was an error updating your customer data. Please contact a site administrator.</p>').fadeIn(300);

    }

  } else {

    $('#verify .form').html('<p class="error">There was an error updating your customer data. Please contact a site administrator.</p>').fadeIn(300);

  }

}

function verifyAge(data) {

  console.log(data); 

  if (data.substr(0, 6) == "Error!") {

    $('#verify .form').html('<p class="error">' + data + 'It seems some of the inserted information was incorrect. Could you please try again while double-checking that all information is correct. <a href="/pages/verify-age">Try again</a>.</p>').fadeIn(300);

  } else {

    var veratad_response = $.parseJSON(data);

    if (veratad_response.error) {

      $('#verify .form').html('<p class="error">It seems some of the inserted information was incorrect. Could you please try again while double-checking that all information is correct. <a href="/pages/verify-age">Try again</a></p>').fadeIn(300);

    } else {

      if (veratad_response.result.action == 'PASS') {

        // modify customer by adding tag "Verified"
        $.ajax({ 
          type: "GET",  
          url: appsdomain + "/tag-verified.php?callback=tagVerified&cid=" + cid,
          dataType: 'jsonp',
          jsonp: 'tagVerified',
          async: 'true',
          success: function(data) {
            // success performed in callback
          }
        });

      } else {

        $('#verify .form').html('<p class="error">It seems some of the inserted information was incorrect. Could you please try again while double-checking that all information is correct. <a href="/pages/verify-age">Try again</a></p>').fadeIn(300);

      }

    }

  }

}
